import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import AnotherProduct from '../../../forms/anotherProduct/AnotherProduct';
import MotiveTitle from '../MotiveTitle';
import ProductColorIcon from '../../../../../../../common/icons/icr_preparando_pedido.svg';

const AnotherProductMobile = ({ ...props }) => {
  const { motiveId, product, profile, type, onData } = props;
  return (
    <Box>
      <MotiveTitle
        icon={ProductColorIcon}
        title="Producto"
        subtitle="Llegó otro producto"
        mobile
      />
      <AnotherProduct
        mobile
        motiveId={motiveId}
        product={product}
        profile={profile}
        type={type}
        onData={onData}
      />
    </Box>
  );
};

AnotherProductMobile.propTypes = {
  motiveId: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  type: PropTypes.string,
  onData: PropTypes.func,
};

export default AnotherProductMobile;
